import React, { useContext, createContext, useState } from "react";

interface PasswordLockContextProps {
    hasModalOpen: boolean
    passwordLockCount: number
    openModal: () => void
    closeModal: () => void
    setPasswordLockCount: (passwordLockCount: number) => void
    increasePasswordLockCount: () => void
}

interface PasswordLockContextType {
    passwordLockModal: PasswordLockContextProps
}

const PasswordLockContext = createContext<PasswordLockContextType>({
    passwordLockModal: {
        hasModalOpen: false,
        passwordLockCount: 0,
        openModal: () => ({}),
        closeModal: () => ({}),
        setPasswordLockCount: () => ({}),
        increasePasswordLockCount: () => ({}),
    }
})

export const usePasswordLockModal = () => useContext(PasswordLockContext)

export const PasswordLockProvider: React.FC = ({ children }) => {
    const [passwordLockCount, setPasswordLockCount] = useState(0)
    const [hasModalOpen, setHasModalOpen] = useState(false)

    const openModal = () => {
        setHasModalOpen(true)
    }

    const closeModal = () => {
        setHasModalOpen(false)
    }

    const increasePasswordLockCount = () => {
        setPasswordLockCount(previousValue => previousValue + 1)
    }

    return (
      <PasswordLockContext.Provider value={{ passwordLockModal: { setPasswordLockCount, passwordLockCount, openModal, closeModal, hasModalOpen, increasePasswordLockCount }}}>
        {children}
      </PasswordLockContext.Provider>
    )
}